import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useCustomers(limit = 200) {
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState(null);

  useEffect(() => {
    setLoading(true);
    const db = firebase.firestore();
    const unsubscribe = db.collection('customers')
      .orderBy('createdAt', 'desc')
      .limit(limit)
      .onSnapshot(
        (snap) => {
          setCustomers(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
          setLoading(false);
        },
        (err) => {
          console.error('[useCustomers] Failed to load customers:', err);
          setCustomers([]);
          setLoading(false);
        }
      );
    return () => unsubscribe();
  }, [limit]);

  return [loading, customers];
}
